import React from 'react'
import SocialButton from '../SocialButton'
import constants from '../../../../common/constants'
import getConfig from '../../../../Helpers/getConfig'

const SocialButtonGroup = () => {
  const whatsAppSelfServiceLink = getConfig('whatsAppSelfServiceLink')

  return (
    <>
      <SocialButton href="https://www.twitter.com/lidercl" alt="twitter-logo" imgSrc="/catalogo/images/X-logo.svg" />
      <SocialButton
        href="https://www.facebook.com/lidercl"
        alt="facebook-logo"
        imgSrc="/catalogo/images/Facebook.svg"
      />
      <SocialButton
        href="https://www.youtube.com/user/supermercadoslider"
        alt="youtube-logo"
        imgSrc="/catalogo/images/Youtube.svg"
      />
      <SocialButton
        href="https://www.instagram.com/lider_cl"
        alt="instagram-logo"
        imgSrc="/catalogo/images/Instagram.svg"
      />
      <SocialButton href="https://www.tiktok.com/@lider_cl" alt="tiktok-logo" imgSrc="/catalogo/images/TikTok.svg" />
      <SocialButton
        href={whatsAppSelfServiceLink || constants.FOOTER.WHATSAPP_SELF_SERVICE_LINK}
        alt="whats-app-logo"
        imgSrc="/catalogo/images/WhatsApp.svg"
        isLast
      />
    </>
  )
}

export default SocialButtonGroup
